import validate from "/app/web/node_modules/nuxt/dist/pages/runtime/validate.js";
import session_45global from "/app/web/middleware/session.global.ts";
import manifest_45route_45rule from "/app/web/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  session_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}